var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LayoutTicketList',{attrs:{"title":"All tickets","navPath":"/tickets","filterSetKey":_vm.filterSetKey,"optionsDefaults":{ sortBy: ['createdUtc'], sortDesc: [true] }}})
}
var staticRenderFns = []

export { render, staticRenderFns }